import { SupportedLocation } from "./types";

export const INTERNATIONAL_LOCATIONS: SupportedLocation[] = [
  // UNITED KINGDOM
  {
    id: "gb-eng-london",
    cityName: "London",
    stateName: "England",
    stateAbbreviation: "ENG",
    countryName: "United Kingdom",
    countryCode: "GB",
    countrySlug: "united-kingdom",
    regionSlug: "england",
    citySlug: "london-eng-gb",
    lat: 51.5074,
    lng: -0.1278,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1820,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["birmingham-eng-gb", "bristol-eng-gb", "manchester-eng-gb"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater London (City of London, Canary Wharf, Shoreditch Tech City, West End)",
      localContextText: "Global financial and fintech capital featuring thousands of boutique law firms, technology agencies, venture funds, healthcare practices, and creative consultancies.",
      majorDistricts: [
        { name: "City of London & Canary Wharf", desc: "Investment banking, corporate law, insurance underwriting, and fintech advisories." },
        { name: "Shoreditch Silicon Roundabout & Old Street", desc: "Software startups, AI research labs, digital marketing, and design studios." },
        { name: "Harley Street Medical District", desc: "World-leading private medical specialists, cosmetic surgeons, and diagnostic centers." }
      ],
      topSectors: [
        { title: "Financial Services & Fintech Engineering", desc: "Algorithmic trading software, payment platforms, and corporate risk advisories." },
        { title: "Commercial Law & Legal Advisories", desc: "Boutique litigation practices, corporate compliance, and intellectual property law." },
        { title: "Private Specialty Healthcare", desc: "Harley Street medical consultancies, outpatient surgical practices, and dental institutes." }
      ],
      majorInstitutions: ["Imperial College London", "UCL (University College London)", "LSE", "King's College London"]
    }
  },
  {
    id: "gb-eng-manchester",
    cityName: "Manchester",
    stateName: "England",
    stateAbbreviation: "ENG",
    countryName: "United Kingdom",
    countryCode: "GB",
    countrySlug: "united-kingdom",
    regionSlug: "england",
    citySlug: "manchester-eng-gb",
    lat: 53.4808,
    lng: -2.2426,
    supportedRadius: 25,
    dataCoverageScore: 96,
    businessCount: 980,
    relevantCategoryCount: 30,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["liverpool-eng-gb", "leeds-eng-gb", "london-eng-gb"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Manchester (MediaCityUK, Spinningfields, Northern Quarter)",
      localContextText: "The economic capital of Northern England leads the UK in e-commerce technology, digital media, bio-health innovation, and advanced materials (graphene).",
      majorDistricts: [
        { name: "Spinningfields Financial & Legal Core", desc: "Commercial law offices, corporate accounting, private equity, and wealth management." },
        { name: "MediaCityUK & Northern Quarter", desc: "Broadcasting technology, digital agency networks, software engineering, and gaming." },
        { name: "Oxford Road Corridor Science Park", desc: "Graphene material research, biotech labs, and health technology incubators." }
      ],
      topSectors: [
        { title: "E-Commerce Technology & Digital Media", desc: "Boutique digital marketing, web application design, and brand agencies." },
        { title: "Advanced Materials & Bio-Health", desc: "Graphene engineering labs, clinical diagnostics, and pharmaceutical research." }
      ],
      majorInstitutions: ["The University of Manchester", "Manchester Metropolitan University (MMU)"]
    }
  },
  {
    id: "gb-eng-birmingham",
    cityName: "Birmingham",
    stateName: "England",
    stateAbbreviation: "ENG",
    countryName: "United Kingdom",
    countryCode: "GB",
    countrySlug: "united-kingdom",
    regionSlug: "england",
    citySlug: "birmingham-eng-gb",
    lat: 52.4862,
    lng: -1.8904,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 910,
    relevantCategoryCount: 29,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["london-eng-gb", "manchester-eng-gb", "bristol-eng-gb"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "West Midlands Metropolitan Area (Colmore Business District, Digbeth Tech)",
      localContextText: "The UK's second largest city is a major automotive engineering (Jaguar Land Rover), financial services, and creative digital hub.",
      majorDistricts: [
        { name: "Colmore Business District", desc: "Financial planning advisories, accounting firms, law offices, and insurance consultancies." },
        { name: "Digbeth Creative Quarter", desc: "Gaming studios, software developers, architecture practices, and media production." }
      ],
      topSectors: [
        { title: "Automotive Engineering & EV Mobility", desc: "Advanced vehicle design, electrical powertrain testing, and tooling." },
        { title: "Financial & Professional Services", desc: "Commercial accounting, tax advisories, legal consultancies, and risk management." }
      ],
      majorInstitutions: ["University of Birmingham", "Birmingham City University", "Aston University"]
    }
  },
  {
    id: "gb-sct-edinburgh",
    cityName: "Edinburgh",
    stateName: "Scotland",
    stateAbbreviation: "SCT",
    countryName: "United Kingdom",
    countryCode: "GB",
    countrySlug: "united-kingdom",
    regionSlug: "scotland",
    citySlug: "edinburgh-sct-gb",
    lat: 55.9533,
    lng: -3.1883,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 810,
    relevantCategoryCount: 28,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["glasgow-sct-gb"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Edinburgh City Region & BioQuarter",
      localContextText: "Scotland's capital is Europe's second largest financial center, world leader in AI software research, and a major life sciences hub.",
      majorDistricts: [
        { name: "George Street & St Andrew Square Financial Core", desc: "Asset management, private banking, pension advisories, and corporate law." },
        { name: "Edinburgh BioQuarter & TechCube", desc: "Artificial intelligence labs, genomics research, software consultancies, and health tech." }
      ],
      topSectors: [
        { title: "Asset Management & Financial Services", desc: "Investment trusts, wealth management, insurance, and fintech." },
        { title: "Artificial Intelligence & Life Sciences", desc: "Informatics labs, drug discovery, health diagnostics, and software design." }
      ],
      majorInstitutions: ["The University of Edinburgh", "Heriot-Watt University", "Edinburgh Napier University"]
    }
  },

  // IRELAND
  {
    id: "ie-l-dublin",
    cityName: "Dublin",
    stateName: "Leinster",
    stateAbbreviation: "L",
    countryName: "Ireland",
    countryCode: "IE",
    countrySlug: "ireland",
    regionSlug: "leinster",
    citySlug: "dublin-l-ie",
    lat: 53.3498,
    lng: -6.2603,
    supportedRadius: 25,
    dataCoverageScore: 98,
    businessCount: 1250,
    relevantCategoryCount: 33,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["cork-m-ie", "galway-c-ie", "belfast-nir-gb"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Dublin Area (Silicon Docks, Grand Canal Dock, IFSC, Sandyford)",
      localContextText: "Europe's premier tech capital houses EMEA headquarters for global tech giants alongside vibrant Irish tech ventures, pharmaceutical leaders, and international law practices.",
      majorDistricts: [
        { name: "Silicon Docks & Grand Canal Dock", desc: "Cloud computing engineering, digital ad tech, cybersecurity labs, and software design." },
        { name: "IFSC (International Financial Services Centre)", desc: "Aviation leasing finance, fund administration, corporate taxation, and legal advisories." }
      ],
      topSectors: [
        { title: "Enterprise Software & Cloud Architecture", desc: "SaaS engineering, DevOps consultancies, cybersecurity, and data analytics." },
        { title: "Aviation Leasing & International Finance", desc: "Aircraft finance law, fund accounting, and corporate compliance." }
      ],
      majorInstitutions: ["Trinity College Dublin (TCD)", "University College Dublin (UCD)", "DCU"]
    }
  },

  // AUSTRALIA
  {
    id: "au-nsw-sydney",
    cityName: "Sydney",
    stateName: "New South Wales",
    stateAbbreviation: "NSW",
    countryName: "Australia",
    countryCode: "AU",
    countrySlug: "australia",
    regionSlug: "new-south-wales",
    citySlug: "sydney-nsw-au",
    lat: -33.8688,
    lng: 151.2093,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1650,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["newcastle-nsw-au", "canberra-act-au", "melbourne-vic-au"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Sydney (CBD, Barangaroo, Tech Central, Macquarie Park)",
      localContextText: "Australia's financial and technology capital, leading the Asia-Pacific in fintech, commercial law, medical technology, and clean energy finance.",
      majorDistricts: [
        { name: "Barangaroo & Martin Place Financial Core", desc: "Investment banking, corporate law, wealth management, and commercial accounting." },
        { name: "Tech Central & Surry Hills Innovation Hub", desc: "Software engineering shops, fintech ventures, creative digital agencies, and design." },
        { name: "Macquarie Park Innovation District", desc: "Biopharmaceuticals, medical device engineering, telecommunications, and diagnostics." }
      ],
      topSectors: [
        { title: "Fintech & Enterprise Software", desc: "Boutique software agencies, payment tech, cloud security, and AI consultancies." },
        { title: "Medical Technology & Bio-Pharmaceuticals", desc: "Orthopedic device labs, clinical diagnostics, and private medical groups." },
        { title: "Corporate Law & Property Services", desc: "Litigation offices, real estate advisories, and tax accounting." }
      ],
      majorInstitutions: ["The University of Sydney", "UNSW Sydney", "UTS (University of Technology Sydney)", "Macquarie University"]
    }
  },
  {
    id: "au-vic-melbourne",
    cityName: "Melbourne",
    stateName: "Victoria",
    stateAbbreviation: "VIC",
    countryName: "Australia",
    countryCode: "AU",
    countrySlug: "australia",
    regionSlug: "victoria",
    citySlug: "melbourne-vic-au",
    lat: -37.8136,
    lng: 144.9631,
    supportedRadius: 30,
    dataCoverageScore: 97,
    businessCount: 1580,
    relevantCategoryCount: 34,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["sydney-nsw-au", "adelaide-sa-au"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Melbourne (CBD, Docklands, Cremorne Tech Hub, Parkville BioMed)",
      localContextText: "Australia's cultural, bio-medical research, and creative software engineering capital.",
      majorDistricts: [
        { name: "Parkville BioMed Precinct", desc: "Global vaccine research, cancer diagnostics, medical devices, and health labs." },
        { name: "Cremorne & Richmond Tech Belt", desc: "Design studios, custom software development, digital marketing, and SaaS startups." },
        { name: "Docklands & Collins Street Commercial Core", desc: "Corporate law firms, accounting advisories, insurance underwriting, and finance." }
      ],
      topSectors: [
        { title: "Bio-Medical Research & Clinical Medicine", desc: "Immunology research, outpatient clinical groups, and dental institutes." },
        { title: "Software & Digital Design", desc: "UX design consultancies, mobile application engineering, and e-commerce tech." }
      ],
      majorInstitutions: ["The University of Melbourne", "Monash University", "RMIT University", "Swinburne University"]
    }
  },
  {
    id: "au-qld-brisbane",
    cityName: "Brisbane",
    stateName: "Queensland",
    stateAbbreviation: "QLD",
    countryName: "Australia",
    countryCode: "AU",
    countrySlug: "australia",
    regionSlug: "queensland",
    citySlug: "brisbane-qld-au",
    lat: -27.4698,
    lng: 153.0251,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 1120,
    relevantCategoryCount: 30,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["gold-coast-qld-au", "sydney-nsw-au"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Brisbane (CBD, Fortitude Valley, Boggo Road Urban Village)",
      localContextText: "Rapidly growing economic engine for green energy technology, mining engineering, health sciences, and tropical agriculture technology.",
      majorDistricts: [
        { name: "Fortitude Valley Tech Quarter", desc: "Software agencies, gaming developers, digital marketing, and design." },
        { name: "Brisbane CBD Financial Core", desc: "Mining engineering consultancies, corporate law, wealth management, and accounting." }
      ],
      topSectors: [
        { title: "Mining Technology & Renewable Energy", desc: "Resource extraction software, environmental impact testing, and solar engineering." },
        { title: "Health Technology & Private Clinics", desc: "Biotech incubators, specialty medical practices, and dental clinics." }
      ],
      majorInstitutions: ["The University of Queensland (UQ)", "QUT (Queensland University of Technology)", "Griffith University"]
    }
  },

  // NEW ZEALAND
  {
    id: "nz-auk-auckland",
    cityName: "Auckland",
    stateName: "Auckland",
    stateAbbreviation: "AUK",
    countryName: "New Zealand",
    countryCode: "NZ",
    countrySlug: "new-zealand",
    regionSlug: "auckland",
    citySlug: "auckland-auk-nz",
    lat: -36.8485,
    lng: 174.7633,
    supportedRadius: 25,
    dataCoverageScore: 95,
    businessCount: 880,
    relevantCategoryCount: 28,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["wellington-wgn-nz", "christchurch-can-nz"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Auckland (CBD, Wynyard Quarter, Viaduct Harbour, Albany)",
      localContextText: "New Zealand's primary commercial capital leading in SaaS software, agritech, marine design, and specialized healthcare.",
      majorDistricts: [
        { name: "Wynyard Quarter Innovation Precinct", desc: "SaaS consultancies, digital agencies, marine engineering, and software startups." },
        { name: "Auckland CBD Financial Core", desc: "Commercial law, wealth management, accounting, and insurance brokerages." }
      ],
      topSectors: [
        { title: "SaaS & Enterprise Technology", desc: "Cloud software design, mobile applications, and cybersecurity." },
        { title: "Agritech & Marine Design", desc: "Horticultural tech, yacht design engineering, and food safety labs." }
      ],
      majorInstitutions: ["The University of Auckland", "AUT (Auckland University of Technology)"]
    }
  },

  // GERMANY
  {
    id: "de-be-berlin",
    cityName: "Berlin",
    stateName: "Berlin",
    stateAbbreviation: "BE",
    countryName: "Germany",
    countryCode: "DE",
    countrySlug: "germany",
    regionSlug: "berlin",
    citySlug: "berlin-be-de",
    lat: 52.52,
    lng: 13.405,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1680,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["hamburg-hh-de", "leipzig-sn-de", "munich-by-de"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Metropolregion Berlin-Brandenburg (Mitte, Kreuzberg, Adlershof Science City)",
      localContextText: "Europe's startup capital leads in AI software, mobility tech, fintech, creative design, and environmental engineering.",
      majorDistricts: [
        { name: "Mitte & Silicon Allee", desc: "Software engineering shops, AI research labs, digital agencies, and fintech." },
        { name: "Adlershof Science and Technology Park", desc: "Optics research, renewable energy labs, materials engineering, and biotech." }
      ],
      topSectors: [
        { title: "Artificial Intelligence & Enterprise SaaS", desc: "Deep learning models, web applications, and developer tooling." },
        { title: "Optics & Clean Energy Engineering", desc: "Solar technology, optical sensors, and environmental testing." }
      ],
      majorInstitutions: ["TU Berlin (Technische Universität Berlin)", "HU Berlin", "FU Berlin"]
    }
  },
  {
    id: "de-by-munich",
    cityName: "München",
    stateName: "Bavaria",
    stateAbbreviation: "BY",
    countryName: "Germany",
    countryCode: "DE",
    countrySlug: "germany",
    regionSlug: "bavaria",
    citySlug: "munich-by-de",
    lat: 48.1351,
    lng: 11.582,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1610,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["stuttgart-bw-de", "berlin-be-de", "frankfurt-he-de"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Metropolregion München (Garching High-Tech Campus, Schwabing, Bogenhausen)",
      localContextText: "Germany's high-tech and industrial software capital (BMW, Siemens) combining deep-tech hardware, automotive engineering, insurance, and medical science.",
      majorDistricts: [
        { name: "Garching Research & High-Tech Campus", desc: "Quantum computing, robotics engineering, aerospace design, and nuclear physics." },
        { name: "Schwabing Tech Corridor", desc: "Enterprise software consultancies, cloud architecture, and industrial design." }
      ],
      topSectors: [
        { title: "Automotive Engineering & Robotics", desc: "Autonomous driving software, industrial automation, and mechanical trades." },
        { title: "Enterprise Technology & Patent Law", desc: "Software engineering, patent consultancies, and corporate finance." }
      ],
      majorInstitutions: ["TUM (Technische Universität München)", "LMU München"]
    }
  },
  {
    id: "de-he-frankfurt",
    cityName: "Frankfurt",
    stateName: "Hesse",
    stateAbbreviation: "HE",
    countryName: "Germany",
    countryCode: "DE",
    countrySlug: "germany",
    regionSlug: "hesse",
    citySlug: "frankfurt-he-de",
    lat: 50.1109,
    lng: 8.6821,
    supportedRadius: 25,
    dataCoverageScore: 97,
    businessCount: 1210,
    relevantCategoryCount: 32,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["cologne-nw-de", "stuttgart-bw-de"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Frankfurt Rhein-Main (Bankenviertel, Gateway Gardens Airport City)",
      localContextText: "Continental Europe's financial capital (ECB, Deutsche Börse) and internet exchange hub (DE-CIX), featuring global banking, cloud infrastructure, and corporate law.",
      majorDistricts: [
        { name: "Bankenviertel Banking District", desc: "Investment banking, corporate compliance law, risk management, and accounting." },
        { name: "Gateway Gardens Data Center Belt", desc: "Cloud infrastructure engineering, cybersecurity, and international logistics." }
      ],
      topSectors: [
        { title: "Financial Engineering & Corporate Law", desc: "Fintech architecture, regulatory compliance law, and wealth management." },
        { title: "Data Center Infrastructure & Logistics", desc: "Network engineering, cloud security, and air cargo forwarding." }
      ],
      majorInstitutions: ["Goethe-Universität Frankfurt", "Frankfurt School of Finance & Management"]
    }
  },

  // FRANCE
  {
    id: "fr-idf-paris",
    cityName: "Paris",
    stateName: "Île-de-France",
    stateAbbreviation: "IDF",
    countryName: "France",
    countryCode: "FR",
    countrySlug: "france",
    regionSlug: "ile-de-france",
    citySlug: "paris-idf-fr",
    lat: 48.8566,
    lng: 2.3522,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1790,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["lyon-ara-fr", "marseille-pac-fr"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Grand Paris (La Défense Financial, Station F Startup Campus, Plateau de Saclay)",
      localContextText: "France's corporate capital holds Europe's largest startup campus (Station F) and leading deep-tech research hub (Plateau de Saclay).",
      majorDistricts: [
        { name: "La Défense Business District", desc: "Corporate law firms, international consultancies, financial advisories, and accounting." },
        { name: "Station F & 13th Arrondissement Tech Core", desc: "AI startups, mobile software agencies, digital design, and fintech." },
        { name: "Plateau de Saclay Innovation Cluster", desc: "Quantum physics, aerospace engineering, nuclear research, and biotech." }
      ],
      topSectors: [
        { title: "AI & Software Engineering", desc: "Deep learning engineering, SaaS design, and web consultancies." },
        { title: "Corporate Legal & Financial Consulting", desc: "M&A law practices, tax consultancies, and private equity." }
      ],
      majorInstitutions: ["Sorbonne Université", "IP Paris (Institut Polytechnique de Paris)", "HEC Paris", "Sciences Po"]
    }
  },

  // JAPAN
  {
    id: "jp-13-tokyo",
    cityName: "Tokyo",
    stateName: "Tokyo",
    stateAbbreviation: "13",
    countryName: "Japan",
    countryCode: "JP",
    countrySlug: "japan",
    regionSlug: "tokyo",
    citySlug: "tokyo-13-jp",
    lat: 35.6762,
    lng: 139.6503,
    supportedRadius: 30,
    dataCoverageScore: 99,
    businessCount: 1850,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["yokohama-14-jp", "nagoya-23-jp", "osaka-27-jp"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Greater Tokyo Area (Marunouchi, Roppongi Hills, Shibuya Tech, Akihabara)",
      localContextText: "The world's largest metropolitan economy leads in robotics engineering, semiconductor design, enterprise software, global finance, and medical innovation.",
      majorDistricts: [
        { name: "Marunouchi & Otemachi Financial Core", desc: "Global investment banking, corporate law offices, trading houses, and accounting." },
        { name: "Shibuya Bit Valley & Roppongi Tech Hub", desc: "Software engineering shops, mobile game studios, AI consultancies, and design." },
        { name: "Odaiba & Ariake Robotics Zone", desc: "Industrial automation testing, robotics labs, and microelectronics R&D." }
      ],
      topSectors: [
        { title: "Robotics & Microelectronics Engineering", desc: "Industrial automation systems, sensor technology, and precision tooling." },
        { title: "Enterprise Software & AI", desc: "Cloud solution architecture, mobile application development, and cybersecurity." },
        { title: "Corporate Legal & Financial Services", desc: "Cross-border transaction law, patent consultancies, and corporate finance." }
      ],
      majorInstitutions: ["The University of Tokyo", "Tokyo Institute of Technology (Tokyo Tech)", "Waseda University", "Keio University"]
    }
  },
  {
    id: "jp-27-osaka",
    cityName: "Osaka",
    stateName: "Osaka",
    stateAbbreviation: "27",
    countryName: "Japan",
    countryCode: "JP",
    countrySlug: "japan",
    regionSlug: "osaka",
    citySlug: "osaka-27-jp",
    lat: 34.6937,
    lng: 135.5023,
    supportedRadius: 25,
    dataCoverageScore: 96,
    businessCount: 1280,
    relevantCategoryCount: 32,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["kyoto-26-jp", "kobe-28-jp", "tokyo-13-jp"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Kansai Metropolitan Region (Umeda North Yard, Namba, Yodogawa)",
      localContextText: "Western Japan's commercial and industrial center specializing in battery technology, pharmaceutical manufacturing, electronics, and robotics.",
      majorDistricts: [
        { name: "Umeda Knowledge Capital", desc: "Software consultancies, health tech labs, architectural firms, and legal offices." },
        { name: "Yodogawa & Sakai Chemical Belt", desc: "Lithium battery R&D, pharmaceutical labs, and precision machinery." }
      ],
      topSectors: [
        { title: "Battery & Chemical Engineering", desc: "EV energy storage research, chemical analysis, and industrial materials." },
        { title: "Pharmaceutical Science & Medicine", desc: "Clinical diagnostic labs, outpatient medical centers, and dental care." }
      ],
      majorInstitutions: ["Osaka University", "Kansai University"]
    }
  },

  // BRAZIL
  {
    id: "br-sp-sao-paulo",
    cityName: "São Paulo",
    stateName: "São Paulo",
    stateAbbreviation: "SP",
    countryName: "Brazil",
    countryCode: "BR",
    countrySlug: "brazil",
    regionSlug: "sao-paulo",
    citySlug: "sao-paulo-sp-br",
    lat: -23.5505,
    lng: -46.6333,
    supportedRadius: 30,
    dataCoverageScore: 98,
    businessCount: 1720,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["rio-de-janeiro-rj-br", "belo-horizonte-mg-br", "curitiba-pr-br"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Região Metropolitana de São Paulo (Avenida Paulista, Faria Lima, Berrini, Pinheiros)",
      localContextText: "Latin America's financial, fintech, tech startup, and corporate powerhouse.",
      majorDistricts: [
        { name: "Avenida Faria Lima & Itaim Bibi", desc: "Investment banking, private equity, corporate law firms, and fintech ventures." },
        { name: "Avenida Paulista Financial Core", desc: "Insurance advisories, accounting firms, medical institutes, and legal offices." },
        { name: "Pinheiros & Vila Madalena Tech Belt", desc: "Software design agencies, web engineering, advertising, and creative studios." }
      ],
      topSectors: [
        { title: "Fintech & Enterprise Software", desc: "Digital banking architecture, mobile applications, and cloud security." },
        { title: "Corporate Legal & Tax Consulting", desc: "Boutique litigation practices, tax consultancies, and M&A law." },
        { title: "Specialty Healthcare & Dental Institutes", desc: "Private outpatient hospitals, cosmetic medicine, and dental surgery." }
      ],
      majorInstitutions: ["USP (Universidade de São Paulo)", "FGV (Fundação Getulio Vargas)", "INSPER", "UNESP"]
    }
  },

  // SINGAPORE
  {
    id: "sg-sg-singapore",
    cityName: "Singapore",
    stateName: "Singapore",
    stateAbbreviation: "SG",
    countryName: "Singapore",
    countryCode: "SG",
    countrySlug: "singapore",
    regionSlug: "singapore",
    citySlug: "singapore-sg-sg",
    lat: 1.3521,
    lng: 103.8198,
    supportedRadius: 20,
    dataCoverageScore: 99,
    businessCount: 1610,
    relevantCategoryCount: 35,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: [],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Republic of Singapore (Marina Bay Financial Centre, One-North R&D, Changi Business Park)",
      localContextText: "Southeast Asia's primary financial, maritime trade, semiconductor design, and cloud data technology capital.",
      majorDistricts: [
        { name: "Marina Bay Financial Centre & Raffles Place", desc: "Global wealth management, corporate law practices, fintech consultancies, and accounting." },
        { name: "One-North R&D Precinct (Biopolis & Fusionopolis)", desc: "Biomedical research labs, microelectronics design, AI labs, and software agencies." }
      ],
      topSectors: [
        { title: "Fintech & Enterprise Cloud Architecture", desc: "Cross-border payment tech, cybersecurity advisories, and SaaS engineering." },
        { title: "Biomedical Science & Clinical Research", desc: "Pharmaceutical testing, outpatient specialty care, and medical device design." }
      ],
      majorInstitutions: ["NUS (National University of Singapore)", "NTU (Nanyang Technological University)", "SMU"]
    }
  },

  // UNITED ARAB EMIRATES
  {
    id: "ae-du-dubai",
    cityName: "Dubai",
    stateName: "Dubai",
    stateAbbreviation: "DU",
    countryName: "United Arab Emirates",
    countryCode: "AE",
    countrySlug: "united-arab-emirates",
    regionSlug: "dubai",
    citySlug: "dubai-du-ae",
    lat: 25.2048,
    lng: 55.2708,
    supportedRadius: 25,
    dataCoverageScore: 98,
    businessCount: 1540,
    relevantCategoryCount: 34,
    priority: 1,
    indexingStatus: "indexed",
    pageEnabled: true,
    lastUpdated: "2026-07-23",
    nearbyLocations: ["abu-dhabi-az-ae"],
    pageTypesEnabled: ["jobs", "businesses-hiring", "internships"],
    localHighlights: {
      metroName: "Emirate of Dubai (DIFC, Internet City, Business Bay, JLT)",
      localContextText: "Middle East's commercial capital leading in international finance, fintech, real estate technology, trade logistics, and AI innovation.",
      majorDistricts: [
        { name: "DIFC (Dubai International Financial Centre)", desc: "Wealth management, corporate law offices, asset management, and fintech labs." },
        { name: "Dubai Internet City & Media City", desc: "Software application engineering, cloud architecture, and digital marketing." }
      ],
      topSectors: [
        { title: "Fintech & Wealth Management", desc: "Investment advisories, asset management software, and cross-border finance." },
        { title: "Software Engineering & Digital Marketing", desc: "Web development, mobile apps, digital strategy, and AI consultancies." }
      ],
      majorInstitutions: ["American University in Dubai (AUD)", "Heriot-Watt University Dubai", "UOWD"]
    }
  }
];
